import { Component, OnInit, ElementRef } from '@angular/core';
import { Router } from "@angular/router";
import {  Observable } from "rxjs";

import { User } from '@app/model/user';
import { AuthService } from '@app/services';

// lista incompleta de emojis
// source: http://www.unicode.org/emoji/charts/full-emoji-list.html
const emojis = [
  { code: '', css: '' }, // icon
  // animal-bird
  { code: '🦃', css: 'emojicode' },
  { code: '🐔', css: 'emojicode' },
  { code: '🐓', css: 'emojicode' },
  { code: '🐣', css: 'emojicode' },
  { code: '🐤', css: 'emojicode' },
  { code: '🐥', css: 'emojicode' },
  { code: '🐦', css: 'emojicode' },
  { code: '🐧', css: 'emojicode' },
  { code: '🕊', css: 'emojichars' },
  { code: '🦅', css: 'emojicode' },
  { code: '🦆', css: 'emojicode' },
  { code: '🦢', css: 'emojicode' },
  { code: '🦉', css: 'emojicode' },
  { code: '🦩', css: 'emojicode' },
  { code: '🦚', css: 'emojicode' },
  { code: '🦜', css: 'emojicode' },
  // animal-amphibian
  { code: '🐸', css: 'emojicode' },
  // animal-reptile
  { code: '🐊', css: 'emojicode' },
  { code: '🐢', css: 'emojicode' },
  { code: '🦎', css: 'emojicode' },
  { code: '🐍', css: 'emojicode' },
  { code: '🐲', css: 'emojicode' },
  { code: '🐉', css: 'emojicode' },
  { code: '🦕', css: 'emojicode' },
  { code: '🦖', css: 'emojicode' },
  // animal-marine
  { code: '🐳', css: 'emojicode' },
  { code: '🐋', css: 'emojicode' },
  { code: '🐬', css: 'emojicode' },
  { code: '🐟', css: 'emojicode' },
  { code: '🐠', css: 'emojicode' },
  { code: '🐡', css: 'emojicode' },
  { code: '🦈', css: 'emojicode' },
  { code: '🐙', css: 'emojicode' },
  // animal-bug
  { code: '🐌', css: 'emojicode' },
  { code: '🦋', css: 'emojicode' },
  { code: '🐛', css: 'emojicode' },
  { code: '🐜', css: 'emojicode' },
  { code: '🐝', css: 'emojicode' },
  { code: '🐞', css: 'emojicode' },
  { code: '🦗', css: 'emojicode' },
  { code: '🕷', css: 'emojicode' },
  { code: '🦂', css: 'emojicode' },
  { code: '🦟', css: 'emojicode' },
  { code: '🦠', css: 'emojicode' },
  // place-map
  { code: '🌍', css: 'emojicode' },
  { code: '🌎', css: 'emojicode' },
  { code: '🌏', css: 'emojicode' },
  // place-geographic
  { code: '🏔', css: 'emojichars' },
  { code: '⛰', css: 'emojichars' },
  { code: '🌋', css: 'emojichars' },
  { code: '🗻', css: 'emojichars' },
  { code: '🏕', css: 'emojichars' },
  { code: '🏖', css: 'emojichars' },
  { code: '🏜', css: 'emojichars' },
  { code: '🏝', css: 'emojichars' },
  // face-costume
  { code: '💩', css: 'emojichars' },
  { code: '🤡', css: 'emojichars' },
  { code: '👹', css: 'emojichars' },
  { code: '👺', css: 'emojichars' },
  { code: '👻', css: 'emojichars' },
  { code: '👽', css: 'emojichars' },
  { code: '👾', css: 'emojichars' },
  { code: '🤖', css: 'emojichars' },
  // monkey-face
  { code: '🙈', css: 'emojichars' },
  { code: '🙉', css: 'emojichars' },
  { code: '🙊', css: 'emojichars' },
  // person
  { code: '👶', css: 'emojichars' },
  { code: '🧒', css: 'emojichars' },
  { code: '👦', css: 'emojichars' },
  { code: '👧', css: 'emojichars' },
  { code: '🧑', css: 'emojichars' },
  { code: '👱', css: 'emojichars' },
  { code: '👨', css: 'emojichars' },
  { code: '🧔', css: 'emojichars' },
  { code: '👨‍🦰', css: 'emojichars' },
  { code: '👨‍🦱', css: 'emojichars' },
  { code: '👨‍🦳', css: 'emojichars' },
  { code: '👨‍🦲', css: 'emojichars' },
  { code: '👩', css: 'emojichars' },
  { code: '👩‍🦰', css: 'emojichars' },
  { code: '👩‍🦱', css: 'emojichars' },
  { code: '👩‍🦳', css: 'emojichars' },
  { code: '👩‍🦲', css: 'emojichars' },
  { code: '👱‍♀️', css: 'emojichars' },
  { code: '👱‍♂️', css: 'emojichars' },
  { code: '🧓', css: 'emojichars' },
  { code: '👴', css: 'emojichars' },
  { code: '👵', css: 'emojichars' },
  // person-gesture
  { code: '🙍', css: 'emojichars' },
  { code: '🙍‍♂️', css: 'emojichars' },
  { code: '🙍‍♀️', css: 'emojichars' },
  { code: '🙎', css: 'emojichars' },
  { code: '🙎‍♂️', css: 'emojichars' },
  { code: '🙎‍♀️', css: 'emojichars' },
  { code: '🙅', css: 'emojichars' },
  { code: '🙅‍♂️', css: 'emojichars' },
  { code: '🙅‍♀️', css: 'emojichars' },
  { code: '🙆', css: 'emojichars' },
  { code: '🙆‍♂️', css: 'emojichars' },
  { code: '🙆‍♀️', css: 'emojichars' },
  { code: '💁', css: 'emojichars' },
  { code: '💁‍♂️', css: 'emojichars' },
  { code: '💁‍♀️', css: 'emojichars' },
  { code: '🙋', css: 'emojichars' },
  { code: '🙋‍♂️', css: 'emojichars' },
  { code: '🙋‍♀️', css: 'emojichars' },
  { code: '🧏', css: 'emojichars' },
  { code: '🧏‍♂️', css: 'emojichars' },
  { code: '🧏‍♀️', css: 'emojichars' },
  { code: '🙇', css: 'emojichars' },
  { code: '🙇‍♂️', css: 'emojichars' },
  { code: '🙇‍♀️', css: 'emojichars' },
  { code: '🤦', css: 'emojichars' },
  { code: '🤦‍♂️', css: 'emojichars' },
  { code: '🤦‍♀️', css: 'emojichars' },
  { code: '🤷', css: 'emojichars' },
  { code: '🤷‍♂️', css: 'emojichars' },
  { code: '🤷‍♀️', css: 'emojichars' },
  // person-role
  { code: '👨‍⚕️', css: 'emojichars' },
  { code: '👩‍⚕️', css: 'emojichars' },
  { code: '👨‍🎓', css: 'emojichars' },
  { code: '👩‍🎓', css: 'emojichars' },
  { code: '👨‍🏫', css: 'emojichars' },
  { code: '👩‍🏫', css: 'emojichars' },
  { code: '👨‍⚖️', css: 'emojichars' },
  { code: '👩‍⚖️', css: 'emojichars' },
  { code: '👨‍🌾', css: 'emojichars' },
  { code: '👩‍🌾', css: 'emojichars' },
  { code: '👨‍🍳', css: 'emojichars' },
  { code: '👩‍🍳', css: 'emojichars' },
  { code: '👨‍🔧', css: 'emojichars' },
  { code: '👩‍🔧', css: 'emojichars' },
  { code: '👨‍🏭', css: 'emojichars' },
  { code: '👩‍🏭', css: 'emojichars' },
  { code: '👨‍💼', css: 'emojichars' },
  { code: '👩‍💼', css: 'emojichars' },
  { code: '👨‍🔬', css: 'emojichars' },
  { code: '👩‍🔬', css: 'emojichars' },
  { code: '👨‍💻', css: 'emojichars' },
  { code: '👩‍💻', css: 'emojichars' },
  { code: '👨‍🎤', css: 'emojichars' },
  { code: '👩‍🎤', css: 'emojichars' },
  { code: '👨‍🎨', css: 'emojichars' },
  { code: '👩‍🎨', css: 'emojichars' },
  { code: '👨‍✈️', css: 'emojichars' },
  { code: '👩‍✈️', css: 'emojichars' },
  { code: '👨‍🚀', css: 'emojichars' },
  { code: '👩‍🚀', css: 'emojichars' },
  { code: '👨‍🚒', css: 'emojichars' },
  { code: '👩‍🚒', css: 'emojichars' },
  { code: '👮‍♂️', css: 'emojichars' },
  { code: '👮‍♀️', css: 'emojichars' },
  { code: '🕵️‍♂️', css: 'emojichars' },
  { code: '🕵️‍♀️', css: 'emojichars' },
  { code: '💂‍♂️', css: 'emojichars' },
  { code: '💂‍♀️', css: 'emojichars' },
  { code: '👷', css: 'emojichars' },
  { code: '👷‍♂️', css: 'emojichars' },
  { code: '🤴', css: 'emojichars' },
  { code: '👸', css: 'emojichars' },
  { code: '👳‍♂️', css: 'emojichars' },
  { code: '👳‍♀️', css: 'emojichars' },
  { code: '👲', css: 'emojichars' },
  { code: '🧕', css: 'emojichars' },
  { code: '🤵', css: 'emojichars' },
  { code: '👰', css: 'emojichars' },
  { code: '🤰', css: 'emojichars' },
  { code: '🤱', css: 'emojichars' },
  { code: '👼', css: 'emojichars' },
  { code: '🎅', css: 'emojichars' },
  { code: '🤶', css: 'emojichars' },
  { code: '🦸‍♂️', css: 'emojichars' },
  { code: '🦸‍♀️', css: 'emojichars' },
  { code: '🦹‍♂️', css: 'emojichars' },
  { code: '🦹‍♀️', css: 'emojichars' },
  { code: '🧙‍♂️', css: 'emojichars' },
  { code: '🧙‍♀️', css: 'emojichars' },
  { code: '🧚‍♂️', css: 'emojichars' },
  { code: '🧚‍♀️', css: 'emojichars' },
  { code: '🧛‍♂️', css: 'emojichars' },
  { code: '🧛‍♀️', css: 'emojichars' },
  { code: '🧜‍♂️', css: 'emojichars' },
  { code: '🧜‍♀️', css: 'emojichars' },
  { code: '🧝', css: 'emojichars' },
  { code: '🧝‍♂️', css: 'emojichars' },
  { code: '🧝‍♀️', css: 'emojichars' },
  { code: '🧞‍♂️', css: 'emojichars' },
  { code: '🧞‍♀️', css: 'emojichars' },
  { code: '🧟‍♂️', css: 'emojichars' },
  { code: '🧟‍♀️', css: 'emojichars' },
  // person-sport
  { code: '🤺', css: 'emojichars' },
  { code: '🏇', css: 'emojichars' },
  { code: '⛷', css: 'emojichars' },
  { code: '🏂', css: 'emojichars' },
  { code: '🏌️‍♂️', css: 'emojichars' },
  { code: '🏌️‍♀️', css: 'emojichars' },
  { code: '🏄‍♂️', css: 'emojichars' },
  { code: '🏄‍♀️', css: 'emojichars' },
  { code: '🚣‍♂️', css: 'emojichars' },
  { code: '🚣‍♀️', css: 'emojichars' },
  { code: '🏊‍♂️', css: 'emojichars' },
  { code: '🏊‍♀️', css: 'emojichars' },
  { code: '⛹️‍♂️', css: 'emojichars' },
  { code: '⛹️‍♀️', css: 'emojichars' },
  { code: '🏋️‍♂️', css: 'emojichars' },
  { code: '🏋️‍♀️', css: 'emojichars' },
  { code: '🚴‍♂️', css: 'emojichars' },
  { code: '🚴‍♀️', css: 'emojichars' },
  { code: '🤹‍♂️', css: 'emojichars' },
  { code: '🤹‍♀️', css: 'emojichars' },
  { code: '', css: 'emojichars' },
  { code: '', css: 'emojichars' },
  { code: '', css: 'emojichars' },
  { code: '', css: 'emojichars' },
  { code: '', css: 'emojichars' },
  { code: '', css: 'emojichars' },
  { code: '', css: 'emojichars' },
  { code: '', css: 'emojichars' },
];


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  user: User;
  showIcon: boolean = true;
  emoji: string = '';
  emojiCssClass: string = '';


  constructor(private authService: AuthService, private router: Router) {
    console.info('navbar.ctor getting utilizador');
    this.user = this.authService.userValue;
    console.info('navbar.ctor.utilizador', this.user);

    console.info('navbar.ctor.user', this.authService.userValue);
    if (this.authService.userValue) {
      console.info('navbar.ctor.user', this.authService.userValue);
      if (this.authService.userValue.username) {
        console.info('navbar.ctor.user.username', this.authService.userValue.username);
      }
    }

    const d = Math.random();
    const i = Math.trunc(d*emojis.length);

    this.showIcon = i == 0;
    if (this.showIcon) {
      this.emoji = '';
      this.emojiCssClass = '';
    } else {
      this.emoji = emojis[i].code;
      this.emojiCssClass = emojis[i].css;
      //console.info('emoji: ', i, this.emoji);
    }
  }

  ngOnInit() {
    console.info('navbar.ngOnInit getting utilizador');
    this.user = this.authService.userValue;
    console.info('navbar.ngOnInit.user', this.user);

  }

  // ngDoCheck() {
  // }

  logout() {
    this.authService.logout();
    // this.router.navigate(["/auth/login"]);
  }

}
